import { jsxs, jsx } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { token } from "./token.js";
import { textStyles } from "./textStyles.js";
function Badge({
  children,
  color = "brand",
  hasBorder = false,
  isPillShaped = false,
  icon,
  isSmall = false,
  isSecondary = false,
  ...props
}) {
  return /* @__PURE__ */ jsxs(BadgeStyled, {
    $color: color,
    $hasBorder: hasBorder,
    $isPillShaped: isPillShaped,
    $isSecondary: isSecondary,
    $isSmall: isSmall,
    ...props,
    children: [icon && /* @__PURE__ */ jsx(IconHolder, {
      $isSmall: isSmall,
      children: icon
    }), children]
  });
}
const BadgeStyled = styled.div.withConfig({
  displayName: "BadgeStyled",
  componentId: "sc-he9ifc-0"
})(["", " display:inline-flex;vertical-align:middle;flex-wrap:nowrap;justify-content:center;align-items:center;box-sizing:border-box;height:", ";padding:0 ", ";border:2px solid transparent;border-radius:", ";color:", ";", ""], textStyles.uiTextXS, (props) => props.$isSmall ? `20px` : `24px`, (props) => props.$isSmall ? token.spacing2 : `6px`, (props) => props.$isPillShaped ? token.radiusPill : token.radiusMedium, token.white, (props) => {
  if (!props.$isSecondary && props.$color) {
    const colors = {
      brand: token.brandPrimary500,
      gray: token.gray400,
      black: token.gray900,
      "black-alpha": token.gray600a,
      green: token.green500,
      blue: token.blue500,
      red: token.red400
    };
    if (props.$hasBorder) {
      return css(["border-color:", ";color:", ";"], colors[props.$color], colors[props.$color]);
    }
    return css(["background-color:", ";"], colors[props.$color]);
  }
  if (props.$isSecondary) {
    return css(["border-color:", ";background-color:", ";color:", ";"], props.$hasBorder ? token.gray100 : `transparent`, props.$hasBorder ? token.white : token.gray100, token.gray800);
  }
});
const IconHolder = styled.div.withConfig({
  displayName: "IconHolder",
  componentId: "sc-he9ifc-1"
})(["display:flex;align-items:center;height:100%;margin-right:", ";margin-left:calc(", " * -1);svg{width:18px;height:18px;}"], (props) => props.$isSmall ? token.spacing1 : token.spacing2, token.spacing1);
export {
  Badge
};
//# sourceMappingURL=Badge.js.map
